export default "__VITE_ASSET__BqjmLrCX__"